export var ACTION;
(function (ACTION) {
    ACTION["CHECK_DIGIO_RESPONSE"] = "CHECK_DIGIO_RESPONSE";
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["RETRY_DIGIO"] = "RETRY_DIGIO";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["SUCCESS_VERIFICATION"] = "SUCCESS_VERIFICATION";
    ACTION["GO_TO_NEXT_STEP"] = "GO_TO_NEXT_STEP";
})(ACTION || (ACTION = {}));
